import {Column, Entity, ManyToOne} from "typeorm";
import type {Relation} from "typeorm";
import {Min} from "class-validator";
import {BaseEntity} from "@/modules/base/entity";
import {Player, Team} from "@/modules/team/entity";
import {Season} from "@/modules/season/entity";

@Entity()
export class TransferLog extends BaseEntity {
  @ManyToOne(() => Season)
  season: Relation<Season>;

  @ManyToOne(() => Team)
  from?: Relation<Team> | null;

  @ManyToOne(() => Team)
  to?: Relation<Team> | null;

  @ManyToOne(() => Player)
  player: Relation<Player>;

  @Column({type: 'date'})
  transferredAt: Date;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  price: number;
}
